import { forwardRef } from "react";
import { cn } from "@/lib/utils";

export interface IconProps extends React.SVGAttributes<SVGElement> {
  children?: never;
  color?: string;
  size?: number;
}

export const Spinner = forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", className, ...props }, forwardedRef) => {
    return (
      <svg
        className={cn("animate-spin duration-1000 -ml-1 mr-3 h-3 w-3 text-muted-foreground/50", className)}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        ref={forwardedRef}
        {...props}
      >
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
        <path
          className="opacity-40"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
    );
  }
);

Spinner.displayName = "Spinner";
export default Spinner;
